// Local store for saved equations. Lives in localStorage so it survives
// across visits. If/when we want cross-device sync, we can mirror this to
// the /me/* endpoints the same way bookmarks work.

import { earnCoins } from "./coins";

const KEY = "vault.equations.v1";
const MAX = 200;

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

const write = (list) => {
  try {
    const capped = list.slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(capped));
    window.dispatchEvent(new Event("equations-changed"));
    return true;
  } catch {
    return false;
  }
};

export const getSavedEquations = () => read();

export const saveEquation = (text, note = "") => {
  const trimmed = (text || "").trim();
  if (!trimmed) return null;
  const list = read();
  // If the exact same equation already exists, just bump it to the top.
  const existingIdx = list.findIndex((e) => e.text === trimmed);
  let entry;
  if (existingIdx >= 0) {
    entry = { ...list[existingIdx], note: note || list[existingIdx].note, updated_at: Date.now() };
    list.splice(existingIdx, 1);
  } else {
    entry = {
      id: `eq_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`,
      text: trimmed,
      note,
      created_at: Date.now(),
      updated_at: Date.now(),
    };
  }
  write([entry, ...list]);
  // Coin award — only on a NEW equation save, not when bumping an existing
  // one to top. Server enforces daily cap.
  if (existingIdx < 0) {
    earnCoins("equation_save", entry.id).then((r) => {
      if (r?.awarded > 0) window.dispatchEvent(new Event("coins-changed"));
    });
  }
  return entry;
};

export const removeEquation = (id) => {
  write(read().filter((e) => e.id !== id));
};

export const renameEquation = (id, note) => {
  write(
    read().map((e) =>
      e.id === id ? { ...e, note, updated_at: Date.now() } : e
    )
  );
};

export const clearEquations = () => write([]);
